import AppModel from '@client/components/App/model'
import EditorModel from '@client/components/Editor/model'
import AutoSave from '@client/utils/Autosave'
import documentSync from '@client/utils/DocumentSync'
import FontLoadModel from '@client/utils/webfonts'
import History from '@client/utils/History'
import { HISTORY_LIMIT, HISTORY_DELAY } from '@client/components/constants'

export const getState = () => {
  const savedItem = {}
  const fontloader = new FontLoadModel([])
  const editorModel = new EditorModel(savedItem)
  const history = new History(HISTORY_LIMIT, HISTORY_DELAY, editorModel)

  const appModel = new AppModel(history)
  AutoSave.unBind()
  AutoSave.bind(editorModel)
  // Keeps an idle tab on the latest server version (FE-1354). Wired here
  // because this is the one place that owns all four collaborators.
  documentSync.bind({ editorModel, appModel, history, fontloader })
  return {
    savedItem,
    editorModel,
    history,
    appModel,
    fontloader,
  }
}
